import React, { Component} from "react";

import TableRow from '@mui/material/TableRow'; 
import TableCell from '@mui/material/TableCell';
import Table from '@mui/material/Table';
  
export default  class Settings extends React.Component {
	
	componentWillMount() {
		
	if(localStorage.getItem("ISIuserid")==null)
		 {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
		   
	 this.props.parentdasCallback(
            "Business Settings~"
        ); 
	}
	render() {
	
return (
<React.Fragment>
  <div className="whitebg">
    <div className="formmain">
    
      <div className="businesssetting">
        <div className="leftpagetitle">
          <h5>Business Preferences</h5>
        </div>

        <div className="pagecontentright">
          <Table>
            <TableRow>
              <TableCell>
                <p className="greencolortext">
                  <a href="/#/Aboutyourbusiness">About your business</a>
                </p>
                <p>Business details included on sales document</p>
              </TableCell>

              <TableCell>
                <p className="greencolortext">
                  <a href="/#/Businesssetting">Record and transactions settings</a>
                </p>
                <p>Change defaults used when creating contact records and transactions</p>
              </TableCell>
            </TableRow>
          </Table>
        </div>
        
        <div className="clear"></div>
      </div>
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	   <div className="businesssetting">
        <div className="leftpagetitle">
          <h5>Document Setting</h5>
        </div>

        <div className="pagecontentright">
          <Table>
            <TableRow>
              <TableCell>
                <p className="greencolortext">
                   <a href="/#/Templateandlogosetting">Templates and Logo</a> 
                </p>
                <p>Change what's shown on invoice and other sales documents</p>
              </TableCell>


			 <TableCell>
                <p className="greencolortext">
                <a href="/#/Mailsettings">Document Emails</a> 
                </p>
                <p>Change the email messages used when you send an invoice, statement or other documents.</p>
              </TableCell>
			
			 </TableRow>
			
			 <TableRow>
			 
              <TableCell>
                <p className="greencolortext">
                <a href="/#/Documentpreference">Document Preference</a> 
                </p>
                <p> Change what's shown on invoices and other sales documents. </p>
              </TableCell>
			  
			  
			  <TableCell>
             
	</TableCell>
			  
            </TableRow>
          </Table>
        </div>
        
        <div className="clear"></div>
      </div>
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	     <div className="businesssetting">
        <div className="leftpagetitle">
          <h5>Financial Setting</h5>
        </div>

        <div className="pagecontentright">
          <Table>
            <TableRow>
              <TableCell>
                <p className="greencolortext">
                   <a href="/#/AdminLedger" >Charts of accounts</a> 
                </p>
                <p>Create, view and manage your ledger accounts.</p>
              </TableCell>


			
			
			 </TableRow>
			
			 <TableRow>
			 
              <TableCell>
                <p className="greencolortext">
                <a href="#/Financialsettings">Financial year and accouting method</a> 
                </p>
                <p> Manage your financial start and year end date. </p>
              </TableCell>
			  
			  
			    <TableCell>
			  <p className="greencolortext">
					<a href="/#/Adminsalestax">Sales taxes</a>
				</p>
                <p>Edit your tax setting </p>
			 </TableCell>
			  
            </TableRow>
			
			
			
			
          </Table>
        </div>
        
        <div className="clear"></div>
      </div>
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  { /*
	     <div className="businesssetting">
        <div className="leftpagetitle">
          <h5>Customize</h5>
        </div>

        <div className="pagecontentright">
          <Table>
            <TableRow>
              <TableCell>
                <p className="greencolortext">
				
                   <a href="#/Navigationanddatagrids">Navigation and data girds</a> 
				   
                </p>
                <p>Create, view and manage your ledger accounts.</p>
              </TableCell>


			
			
			 </TableRow>
			
			
          </Table>
        </div>
        
        <div className="clear"></div>
      </div>
	  
	  */}
	  
	  
	  

    </div>
  </div>
</React.Fragment>


		   )
	}
}
	
	
	 





 



	
	





